export default __webpack_public_path__ + "static/media/ceres-robo-map.8ee5e7bc.png";